import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLogout } from 'pages/Header/Content/hooks/useLogin';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { BigActionCard, StepText } from 'components';
import GiftsLayout from 'components/gifts-table/GiftsLayout';
import giftIcon from 'assets/img/iconregalo.svg';
import configIcon from 'assets/img/config-icon.svg';
import qrIcon from 'assets/img/qr-icon.svg';
import GenericHeroHeader from 'components/gifts-table/GenericHeroHeader';
import { getGiftTable } from 'services/api/table';
import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStorage64 } from 'hooks';
import { AGENT_STAFF, CURRENT_GIFT_TABLE, SEARS_PRODUCT } from 'constants/storage64';
import { encodeStorage, decodeStorage, removeStorage } from 'functions/storageBase64';
import { COUPON_TEXT } from 'constants/values/coupons';
import { PROJECT_BASENAME } from 'constants/env';
import styles from './styles.module.scss';

const ThankYou = () => {
  const history = useHistory();
  const [giftTable, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [agentStaffID] = useStorage64(AGENT_STAFF, '');
  const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const [applyBonification, setApplyBonification] = useState(false);
  const [coupon, setCoupon] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { logOut } = useLogout();

  useEffect(() => {
    removeStorage('isByPass');
    encodeStorage('isChangedGiftTable', true);
    const savedUrl = decodeStorage(SEARS_PRODUCT);
    if(savedUrl && savedUrl.length) {
      window.location.href = `${PROJECT_BASENAME}agregar-regalos`
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(async () => {
    if (giftTable) {
      try {
        dispatch(showLoader());
        console.log('ThankYou: ', giftTable.id || storageGiftTable.id )
        const info = await getGiftTable(giftTable.id || storageGiftTable.id);
        setApplyBonification(info.applyBonification);
        setCoupon(info.coupon);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      } finally {
        dispatch(hideLoader());
      }
    }
  }, [giftTable, storageGiftTable]);

  const endAgentSession = () => {
    logOut();
    removeStorage(AGENT_STAFF);
    history.push(`/admin-login/${agentStaffID}`);
  };

  return (
    <GiftsLayout>
      <section className={styles.ThankYou}>
        <GenericHeroHeader
          icon={giftIcon}
          title="Gracias por crear tu mesa con nosotros"
          subtitle="Te invitamos a:"
          className="pb-0 mb-4"
        />

        <Container className="mt-4 pt-3">
          <div>
            <Row className={styles.ThankYouActions}>
              {!agentStaffID && (
                <>
                  <Col lg={4}>
                    <div className={styles.ThankYouActionsCardContainer}>
                      <BigActionCard
                        variant="separate"
                        image={configIcon}
                        number="1"
                        title="Personalizar tu mesa"
                        description="Selecciona tu portada, mensajes y preferencias"
                        actionLabel="Mi mesa"
                        className={styles.ThankYouActionsCard}
                        onAction={() => history.push('/my-table')}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className={styles.ThankYouActionsCardContainer}>
                      <BigActionCard
                        variant="separate"
                        image={giftIcon}
                        number="2"
                        title="Escoger tus regalos"
                        description="Agregar productos a tu mesa"
                        actionLabel="Agregar productos"
                        className={styles.ThankYouActionsCard}
                        onAction={() => history.push('/agregar-regalos')}
                      />
                    </div>
                  </Col>
                </>
              )}
              
                <Col lg={agentStaffID ? { span: 4, offset: 4 } : 4}>
                {isLoading
                  ?
                  <div className={styles.ThankYouActionsCardContainer}>
                    <div className={[styles.ThankYouActionsSkeleton, styles.ThankYouActionsSkeletonText].join(' ')} />
                    <div className={[styles.ThankYouActionsSkeleton, styles.ThankYouActionsSkeletonBody].join(' ')} />
                  </div>
                  : coupon || applyBonification ?
                  <div
                    className={`${styles.ThankYouActionsCardContainer} ${styles.couponContainer} m-auto`}
                  >
                    
                    <StepText
                      number={agentStaffID ? null : 3}
                      title="Canjear tu regalo de bienvenida"
                      className="mb-3 mb-lg-2 justify-content-center"
                    />

                    <div
                      className={`${styles.coupon} ${styles.ThankYouActionsCard} m-auto`}
                    >
                      <div className={styles.info}>
                        <span className={styles.label}>CUPÓN DE REGALO</span>
                        <span>
                          <p className={styles.notes}>{COUPON_TEXT}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  :
                  <div className={styles.ThankYouActionsCardContainer}>
                    <BigActionCard
                      variant="separate"
                      image={qrIcon}
                      number={agentStaffID ? null : 3}
                      title="Comparte tu evento"
                      description="Comparte con familiares y amigos"
                      actionLabel="Compartir"
                      className={styles.ThankYouActionsCard}
                      onAction={() => history.push('/compartir-mesa')}
                    />
                  </div>
                }
                {agentStaffID && (
                  <Button
                    className="mt-4"
                    type="primary"
                    block
                    onClick={endAgentSession}
                  >
                    Cerrar
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </GiftsLayout>
  );
};

export default ThankYou;
